import { memo, type ReactNode, useMemo } from 'react';

import {
  TaggingContext,
  type TaggingContextData,
  type TaggingData,
} from '@/context/tagging';

type TaggingProviderProps = {
  children: ReactNode;
  handler?: (data: TaggingData) => void;
};

function TaggingProvider({ children, handler }: TaggingProviderProps) {
  const value: TaggingContextData = useMemo(() => {
    return {
      dispatchTaggingEvent: (data) => {
        handler?.(data);
      },
    };
  }, [handler]);

  return (
    <TaggingContext.Provider value={value}>{children}</TaggingContext.Provider>
  );
}

export default memo(TaggingProvider);
